import Text, { TextProps } from '@components/Text/Text';
import {
  FormControlLabel,
  FormControlLabelProps,
  TypographyProps,
  useTheme,
} from '@mui/material';
import React from 'react';
import { StyledToggle } from './Toggle.styles';

interface ToggleProps extends Omit<FormControlLabelProps, 'control'> {
  labelProps?: TextProps & Omit<TypographyProps, 'fontWeight'>;
}

const Toggle: React.FC<ToggleProps> = ({
  label = '',
  labelPlacement = 'start',
  sx,
  checked,
  labelProps,
  ...restProps
}) => {
  const theme = useTheme();

  return (
    <FormControlLabel
      sx={{
        justifyContent: 'space-between',
        opacity: restProps.disabled ? 0.5 : 1,
        alignItems: 'center',
        ...sx,
      }}
      label={
        <Text
          sx={{
            color: checked
              ? theme.palette.primary.main
              : theme.palette.grey.A100,
          }}
          variant='body'
          fontWeight='fontWeightSemiBold'
          {...labelProps}
        >
          {label}
        </Text>
      }
      color='primary'
      labelPlacement={labelPlacement}
      checked={checked}
      control={<StyledToggle labelPlacement={labelPlacement} />}
      {...restProps}
    />
  );
};

export default Toggle;
